export const RMS_GET_CLOUD_STORAGE_DATA_REQUEST =
  'RMS_GET_CLOUD_STORAGE_DATA_REQUEST';
export const RMS_GET_CLOUD_STORAGE_DATA_SUCCESS =
  'RMS_GET_CLOUD_STORAGE_DATA_SUCCESS';
export const RMS_GET_CLOUD_STORAGE_DATA__FAILED =
  'RMS_GET_CLOUD_STORAGE_DATA__FAILED';
